// extracted by mini-css-extract-plugin
module.exports = {"marketing__divider":"divider_marketing__divider__Nq3tX","marketing__divider_icon":"divider_marketing__divider_icon__QnDEY"};